module.exports = __webpack_public_path__ + "img/client-5.630dc0bf.png";